import { Component } from '@angular/core';
import { CustomFacade } from '@piqet-angular/data';
import { commonEnum } from '@piqet-angular/shared';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'piqet-angular-grid-icon',
  templateUrl: './grid-icon.component.html',
  styleUrls: ['./grid-icon.component.css'],
})
export class GridIconComponent {
  params: any;
  images = [
    './assets/images/Plane.svg',
    './assets/images/Truck.svg',
    './assets/images/Boat.svg',
    './assets/images/cycle.svg',
    './assets/images/motorbike.svg',
    './assets/images/Train.svg',
    './assets/images/walking.svg',
    './assets/images/Car.svg',
  ];
  icons: any = [];
  commonEnum = commonEnum;
  transportType: any;
  transportIcons: any;
  distance: any;
  locationTransportationItems: any = [];
  tempData: any = [];
  cityname: any;
  tooltipdata: any = [];
  datatransport: any = [];
  newList: any = [];
  consumerImage: any;
  constructor(private customFacade: CustomFacade) {}

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    let origin = '';
    this.transportType = this.params.data.transportModeName;
    this.transportIcons =
      this.params.data?.transportIcons ||
      this.params.data?.storageTransportDetail ||
      this.params.data?.componentTransportDetail ||
      this.params.data?.fillingTransportDetail ||
      this.params.data?.productTransportItems;
    this.distance = this.params.data.distance;
    this.locationTransportationItems =
      this.params.data.transportationId == 2 && !!this.params.data.locationTransportationItems
        ? this.params.data.locationTransportationItems
        : this.params.data.transportationId == 3 && !!this.params.data.distanceTransportationItems
        ? this.params.data.distanceTransportationItems
        : this.params.data.transportationId == 4 && this.params.data?.checkEolPreRetail
        ? this.params.data.customTransportationItems
        : this.transportIcons;
    let indexCounter = 0;
    this.locationTransportationItems?.map((ele: any) => {
      let index = indexCounter - 1;
      let startRecord = this.locationTransportationItems[index];
      origin = ele?.isOrigin ? ele?.cityName : startRecord?.cityName;
      if (!ele) {
        indexCounter++;
        return;
      } else if (ele?.imageName == 'Plane.png' || ele == 'Plane.png') {
        this.icons.push({
          img: this.images[0],
          startPoint: `${origin}`,
          endPoint: `${ele.cityName}`,
          distance: `${ele.distance}`,
          unit: `${ele.unit || 'km'}`,
          transportModeName: `${ele.transportModeName}`,
        });
      } else if (ele?.imageName == 'Truck.png' || ele == 'Truck.png') {
        this.icons.push({
          img: this.images[1],
          startPoint: `${origin}`,
          endPoint: `${ele.cityName}`,
          distance: `${ele.distance}`,
          unit: `${ele.unit || 'km'}`,
          transportModeName: `${ele.transportModeName}`,
        });
      } else if (ele?.imageName == 'Boat.png' || ele == 'Boat.png') {
        this.icons.push({
          img: this.images[2],
          startPoint: `${origin}`,
          endPoint: `${ele.cityName}`,
          distance: `${ele.distance}`,
          unit: `${ele.unit || 'km'}`,
          transportModeName: `${ele.transportModeName}`,
        });
      } else if (ele?.imageName == 'cycle.png' || ele == 'cycle.png') {
        this.icons.push({
          img: this.images[3],
          startPoint: `${origin}`,
          endPoint: `${ele.cityName}`,
          distance: `${ele.distance}`,
          unit: `${ele.unit || 'km'}`,
          transportModeName: `${ele.transportModeName}`,
        });
      } else if (ele?.imageName == 'motorbike.png' || ele == 'motorbike.png') {
        this.icons.push({
          img: this.images[4],
          startPoint: `${origin}`,
          endPoint: `${ele.cityName}`,
          distance: `${ele.distance}`,
          unit: `${ele.unit || 'km'}`,
          transportModeName: `${ele.transportModeName}`,
        });
      } else if (ele?.imageName == 'Train.png' || ele == 'Train.png') {
        this.icons.push({
          img: this.images[5],
          startPoint: `${origin}`,
          endPoint: `${ele.cityName}`,
          distance: `${ele.distance}`,
          unit: `${ele.unit || 'km'}`,
          transportModeName: `${ele.transportModeName}`,
        });
      } else if (ele?.imageName == 'walking.png' || ele == 'walking.png') {
        this.icons.push({
          img: this.images[6],
          startPoint: `${origin}`,
          endPoint: `${ele.cityName}`,
          distance: `${ele.distance}`,
          unit: `${ele.unit || 'km'}`,
          transportModeName: `${ele.transportModeName}`,
        });
      } else if (ele?.imageName == 'Car.png' || ele == 'Car.png') {
        this.icons.push({
          img: this.images[7],
          startPoint: `${origin}`,
          endPoint: `${ele.cityName}`,
          distance: `${ele.distance}`,
          unit: `${ele.unit || 'km'}`,
          transportModeName: `${ele.transportModeName}`,
        });
      }
      indexCounter++;
    });
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }
}
